const LOG_LEVELS = [
  'ERROR',
  'WARN',
  'INFO',
  'DEBUG',
];


export {
  LOG_LEVELS,
};

export default {
  LOG_LEVELS,
};
